/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @author Yakov Gushchin
 * @version 1.20.1
 * @since 1.14.0
 */

import { IWizardAdditionalAccountsReducer } from './wizardAdditionalAccountsReducer';

export enum EWizardAdditionalAccountsSteps {
    StepSelectParams = 'AdditionalAccountsPrepareStep',
    StepConfirmation = 'AdditionalAccountsConfirmStep',
}

export enum EWizardAdditionalAccountsFieldList {
    COST = 'cost',
    DELETE = 'delete',
    MSISDN = 'msisdn',
    STATUS = 'status',
}

export enum EWizardAdditionalAccountsOperationType {
    CONNECT = 'CONNECT',
    DISCONNECT = 'DISCONNECT',
}

export const initWizardAdditionalAccountsState: IWizardAdditionalAccountsReducer = {
    activateTypes: [],
    deactivateTypes: [],
    isAgreementCheckboxEnabled: false,
    isOnlineCheckProceeded: false,
    offerLink: '',
    orderResult: {
        sumCharge: 0,
        orderSubs: [],
    },
    removedSubscribers: [],
    selected: {
        isActivateAdditionalAccounts: false,
        isDeactivateAdditionalAccounts: false,
        isActivatePersonalAccount: false,
        isActivateContentAccount: false,
        isDeactivatePersonalAccount: false,
        isDeactivateContentAccount: false,
    },
    subscriberIds: [],
    validation: {
        error: '',
        isValid: false,
    },
};

/*
* -------------------------------------------
*           ACTIONS
* -------------------------------------------
*/

export const WIZARD_ADDITIONAL_ACCOUNTS_HANDLE_NEXT = '@@b2b_portal_ui/wizardAdditionalAccounts/WIZARD_ADDITIONAL_ACCOUNTS_HANDLE_NEXT';

export const WIZARD_ADDITIONAL_ACCOUNTS_SET_PARAMS = '@@b2b_portal_ui/wizardAdditionalAccounts/WIZARD_ADDITIONAL_ACCOUNTS_SET_PARAMS';

export const WIZARD_ADDITIONAL_ACCOUNTS_START_VALIDATE = '@@b2b_portal_ui/wizardAdditionalAccounts/WIZARD_ADDITIONAL_ACCOUNTS_START_VALIDATE';
export const WIZARD_ADDITIONAL_ACCOUNTS_SET_STEP_VALID = '@@b2b_portal_ui/wizardAdditionalAccounts/WIZARD_ADDITIONAL_ACCOUNTS_SET_STEP_VALID';
